
<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="previewCertificate(params.data)"
            >Preview</vs-dropdown-item
          >
          <vs-dropdown-item  disabled  v-if="params.data.is_shared == true"
            >Shared</vs-dropdown-item
          >
          <vs-dropdown-item
          v-if="params.data.is_shared == false"
            @click="deleteItem(params.data.certificate_id, 'single')"
            >Delete</vs-dropdown-item
          >
          <vs-dropdown-item
            
            @click="singleImageDownload(params.data.certificate_id)"
            >Download as Image</vs-dropdown-item
          ><vs-dropdown-item
            
            @click="singlePdfDownload(params.data.certificate_id)"
            >Download as PDF</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererAction",
  data() {
    return {};
  },

  methods: {
    previewCertificate(data) {
        console.log(this.params.colDef.cellRendererParams)
      this.params.colDef.cellRendererParams.previewCertificate(data);
    },

    share(editingObject,type) {
      this.params.colDef.cellRendererParams.share(editingObject,type);
    },
    deleteItem(editingObject,type) {
      this.params.colDef.cellRendererParams.delete(editingObject,type);
    },
    singleImageDownload(editingObject) {
      this.params.colDef.cellRendererParams.singleImageDownload(editingObject);
    },
    singlePdfDownload(id) {
      this.params.colDef.cellRendererParams.singlePdfDownload(id);
    }
  }
};
</script>
